import { SLOTS } from './slots.js'

// Admin users. Simple scalar entity; primary links to the edit page (no detail page).
export default {
  key: 'admin',
  label: 'Admin',
  icon: 'admins',
  columns: [
    { slot: SLOTS.PRIMARY, field: 'name', link: 'url' },
    {
      slot: SLOTS.STATUS,
      field: 'verified',
      label: 'Verified',
      renderer: 'boolean',
      trueLabel: 'Verified',
      falseLabel: 'Invitation pending',
      align: 'center'
    },
    { slot: SLOTS.METADATA, field: 'email', label: 'Email' },
    {
      slot: SLOTS.METADATA,
      // Friendly labels come from the server (AdminsController::ABILITY_LABELS) so
      // the column and the edit form's checkboxes always word abilities identically.
      // The server hides it from admins who can't manage permissions (`hidden_columns`).
      field: 'ability_labels',
      label: 'Permissions',
      renderer: 'tags',
      max: 3
    }
  ],
  empty: { icon: 'admins', message: 'No admins found.' },
  defaultView: 'table',
  compact: { show: [SLOTS.PRIMARY, SLOTS.STATUS] }
}
